import { usePreferences } from '@atom/hooks/usePreferences';
import { useUserProfile } from '@atom/hooks/useUserProfile';
import { MapCamera } from '@atom/types/map';

import { DEFAULT_MAP_CENTER, DEFAULT_MAP_ZOOM } from '../mapConfig';
import { getGoogleShapeCenter, isPoint } from '../mapUtilities';

// The camera a map opens at when the view has no explicit center/zoom of its
// own (no URL params yet, first visit).
//
// Center priority:
//   1. Logged-in user's location
//   2. Map center from tenant preferences
//   3. Default center of the United States
//
// Zoom priority:
//   1. Zoom level from tenant preferences
//   2. Default zoom level of 5 (whole United States)
const useDefaultMapLocation = (): MapCamera => {
  const { location } = useUserProfile();
  const preferences = usePreferences();

  return {
    center: isPoint(location)
      ? getGoogleShapeCenter(location)
      : (preferences.map?.center ?? DEFAULT_MAP_CENTER),
    zoom: preferences.map?.zoom || DEFAULT_MAP_ZOOM,
  };
};

export default useDefaultMapLocation;
